<template>
  <section class="home">
    <!-- carousel -->
    <div class="carousel">
      <Carousel></Carousel>
    </div>

    <section class="hero hero-margin-top">
      <div class="hero-body">
        <div class="container">
          <img :src="require('assets/hero@2x.png')" alt="">
          <FirstNetworkStatus class="is-hidden-mobile"></FirstNetworkStatus>
          <FirstNetworkStatusMobile class="is-hidden-tablet"></FirstNetworkStatusMobile>
        </div>
      </div>
    </section>

    <section class="hero hero-deals">
      <div class="hero-body">
        <div class="container has-text-centered deals-bg">
          <p class="title deals-title">最新交易</p>
        </div>
      </div>
    </section>

    <!-- transaction table -->
    <div class="section has-padding-vertical">
      <div class="container">
        <div class="content">
          <transaction-table></transaction-table>
        </div>
      </div>
    </div>

    <!-- network briefing -->
    <section class="hero hero-deals has-padding-vertical">
      <div class="hero-body">
        <div class="container has-text-centered internet-bg">
          <p class="title deals-title">网络概况</p>
        </div>
      </div>
    </section>

    <!-- decentralize -->
    <section class="is-hidden">
      <div class="notification is-light">
        <div class="container">
          <span class="has-text-weight-bold">{{ $t("res.slogan", {coin: this.$CoinName}) }}</span>
          <span>{{ $t("res.slogan_address", {coin: this.$CoinName}) }}</span>
          <code class="has-background-light is-size-5">29ddee7880d6dd82324674776cae452c3cba13fd</code>
        </div>
      </div>
    </section>

    <!-- network status -->
    <div class="section has-padding-vertical">
      <div class="container">
        <div class="content is-hidden">
          <div class="is-flex section-title">
            <h2 class="has-text-info is-marginless">{{ $t("nav.network_stats") }}</h2>
          </div>
        </div>
        <network-status></network-status>
      </div>
    </div>
  </section>
</template>

<script>
  import Carousel from '../components/layout/Carousel'
  import FirstNetworkStatus from '../components/layout/FirstNetworkStatus'
  import FirstNetworkStatusMobile from '../components/layout/FirstNetworkStatusMobile'
  import TransactionTable from '../components/layout/TransactionTable'
  import NetworkStatus from '../components/layout/NetworkStatus'
  import LiveTag from '../components/layout/LiveTag'

export default {
    name: 'Home',
    components: {Carousel, FirstNetworkStatus, FirstNetworkStatusMobile, LiveTag, NetworkStatus, TransactionTable}
  }
</script>

<style lang="scss" type="text/scss">
  .section {
    padding: 1rem 1.5rem;
  }

  .carousel {
    margin-top: -6%;
  }

  @media screen and (max-width: 768px) {
    .hero-margin-top {
      margin-top: 2%;
    }

    .carousel {
      margin-top: -12%;
      padding-bottom: 8%;
    }

    .hero-deals {
      margin-top: 4rem;
    }
  }

  @media screen and (min-width: 769px) {
    .hero-margin-top {
      margin-top: 15%;
    }

    .hero-deals {
      margin-top: 0;
    }
  }

  @media screen and (min-width: 1087px) {
    .hero-margin-top {
      margin-top: 15%;
    }

    .hero-deals {
      margin-top: 0;
    }
  }

  @media screen and (min-width: 1088px) {
    .hero-margin-top {
      margin-top: 20%;
    }

    .hero-deals {
      margin-top: 0;
    }
  }

  @media screen and (min-width: 1280px) {
    .hero-deals {
      margin-top: 2rem;
    }
  }

  @media screen and (min-width: 1440px) {
    .hero-deals {
      margin-top: 7rem;
    }
  }

  .hero-body {
    .container {
      max-width: 100%;
      width: 100%;
      padding: 0!important;
      text-align: center;
    }
    padding: 0!important;
  }

  .section-title {
    padding-top: 1rem;
    margin-bottom: 1rem;
    align-items: flex-end;

    h2 {
      padding-left: 4rem;
    }

    p {
      padding-left: 1rem;
      color: #999999;
    }

    a {
      padding-left: 0.2rem;
      padding-bottom: 0.26rem;
    }
  }

  .has-padding-vertical {
    padding-top: 6rem;
  }

  .deals-bg {
    background-image: url("../assets/deal@2x.png");
    background-size: cover;
    background-position: center;
  }

  .internet-bg {
    background-image: url("../assets/internet@2x.png");
    background-size: cover;
    background-position: center;
  }

  .deals-title {
    padding-top: 2rem;
    padding-bottom: 2rem;
    color: #fff;
    font-size: 4rem;
    font-weight: normal;
  }

  @media screen and (max-width: 768px) {
    .deals-title {
      padding-top: 1rem;
      padding-bottom: 1rem;
      font-size: 2rem;
    }
  }

  @media screen and (min-width: 769px) {
    .deals-title {
      padding-top: 2rem;
      padding-bottom: 2rem;
      font-size: 3rem;
    }
  }

  @media screen and (min-width: 1087px) {
    .deals-title {
      padding-top: 2rem;
      padding-bottom: 2rem;
      font-size: 4rem;
    }
  }

</style>




// WEBPACK FOOTER //
// src/views/Home.vue